package com.karawek.core.ui.theme

import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

object CoreSpacing {
    // Base 4px grid
    val xxs    = 2.dp
    val xs     = 4.dp
    val sm     = 8.dp
    val smPlus = 12.dp  // inner card / form gap
    val md     = 16.dp  // card padding
    val gutter = 20.dp  // screen side gutter
    val lg     = 24.dp  // component spacing
    val xl     = 32.dp  // between grouped sections
    val xxl    = 40.dp
    val xxxl   = 48.dp
    val huge   = 64.dp
}
